import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a73983f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "rootRef",
  class: "setting"
}
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = ["disabled", "onClick"]
const _hoisted_4 = { class: "setting__action-label" }
const _hoisted_5 = ["disabled", "onClick"]
const _hoisted_6 = { class: "setting__action-label" }
const _hoisted_7 = {
  key: 1,
  class: "setting__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconGear = _resolveComponent("IconGear")!
  const _component_Can = _resolveComponent("Can")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      ref: "triggerRef",
      type: "button",
      class: _normalizeClass(["setting__trigger", { 'setting__trigger--open': _ctx.isOpen }]),
      "aria-haspopup": "menu",
      "aria-expanded": String(_ctx.isOpen),
      onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["stop"]))
    }, [
      _createVNode(_component_IconGear, { class: "setting__trigger-icon" })
    ], 42, _hoisted_2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "setting-dropdown" }, {
        default: _withCtx(() => [
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref: "dropdownRef",
                class: "setting__dropdown",
                style: _normalizeStyle(_ctx.dropdownStyle),
                role: "menu",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, [
                (_ctx.actions.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.actions, (action, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `${action.label}-${index}`
                      }, [
                        (_ctx.hasCanConfig(action))
                          ? (_openBlock(), _createBlock(_component_Can, {
                              key: 0,
                              all: _ctx.actionCanProps(action).all,
                              any: _ctx.actionCanProps(action).any,
                              not: _ctx.actionCanProps(action).not
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.actionTooltip(action) ? 'el-tooltip' : 'span'), _normalizeProps(_guardReactiveProps(
                    _ctx.actionTooltip(action)
                      ? { content: _ctx.actionTooltip(action), placement: 'left' }
                      : {}
                  )), {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["setting__action-wrapper", {
                      'setting__action-wrapper--disabled':
                        _ctx.isActionDisabled(action),
                    }])
                                    }, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "setting__action",
                                        disabled: _ctx.isActionDisabled(action),
                                        role: "menuitem",
                                        onClick: ($event: any) => (_ctx.handleActionClick(action))
                                      }, [
                                        (_ctx.iconComponent(action))
                                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.iconComponent(action)), {
                                              key: 0,
                                              class: "setting__action-icon"
                                            }))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(action.label), 1)
                                      ], 8, _hoisted_3)
                                    ], 2)
                                  ]),
                                  _: 2
                                }, 1040))
                              ]),
                              _: 2
                            }, 1032, ["all", "any", "not"]))
                          : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.actionTooltip(action) ? 'el-tooltip' : 'span'), _normalizeProps(_mergeProps({ key: 1 }, 
                  _ctx.actionTooltip(action)
                    ? { content: _ctx.actionTooltip(action), placement: 'left' }
                    : {}
                )), {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["setting__action-wrapper", {
                    'setting__action-wrapper--disabled':
                      _ctx.isActionDisabled(action),
                  }])
                                }, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "setting__action",
                                    disabled: _ctx.isActionDisabled(action),
                                    role: "menuitem",
                                    onClick: ($event: any) => (_ctx.handleActionClick(action))
                                  }, [
                                    (_ctx.iconComponent(action))
                                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.iconComponent(action)), {
                                          key: 0,
                                          class: "setting__action-icon"
                                        }))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(action.label), 1)
                                  ], 8, _hoisted_5)
                                ], 2)
                              ]),
                              _: 2
                            }, 1040))
                      ], 64))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, " Không có hành động "))
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 512))
}